import { useContext } from 'react';
import { AnimationContext } from './animationContext';

export const useIsAnimationEnabled = (): boolean => {
  const { disableAnimations } = useContext(AnimationContext);

  return !disableAnimations;
};
